module.exports = __webpack_public_path__ + "static/media/close.f4ff11bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/close.svg
// module id = 1247
// module chunks = 0